package io.peekandpoke.ultra.streams.ops

import io.peekandpoke.ultra.streams.Stream

/**
 * Records the latest incoming values up to the given [capacity].
 *
 * Each value copies the list (up to [capacity] entries), so a producer emitting many times a second pays that each
 * time: sample it first, `source.sampled(every = 250.milliseconds).history(480)`, which also gives a time axis.
 */
fun <T> Stream<T>.history(capacity: Int): Stream<List<T>> {
    return fold(emptyList()) { acc, next ->
        acc.plus(next).takeLast(capacity)
    }
}

/**
 * Records the latest incoming values that are not null up to the given [capacity].
 *
 * Each value copies the list, as [history] does: sample a fast producer first.
 */
fun <T> Stream<T?>.historyOfNonNull(capacity: Int): Stream<List<T>> {
    return foldNotNull(emptyList()) { acc, next ->
        acc.plus(next).takeLast(capacity)
    }
}
